if(!customElements.get('posted-successfully')) {
  /**
   * The PostedSuccessfully class is a class for extended posted-successfully tag.
   */
  class PostedSuccessfully extends HTMLElement {
    /**
     * The constructor method is a special method of a class for creating
     * and initializing an object instance of that class.
     */
    constructor() {
      super();
      const name = 'posted-successfully';
      this.posted = this.dataset.posted === 'true';
      this.form = this.closest('form');
      const sessionStorageValue = JSON.parse(sessionStorage.getItem(name));
      if (this.form && this.posted && sessionStorageValue != null && sessionStorageValue) {
        Shopify.analytics.publish('form_submit', sessionStorageValue);
        sessionStorage.removeItem(name);
      }
    }
  }
  customElements.define('posted-successfully', PostedSuccessfully)
}

/**
 * The setFormDataForPostedSuccessfully method is a special method for set
 * form data to section store. Only form with posted-successfully tag.
 * @name setFormDataForPostedSuccessfully
 * @kind function
 * @param {Event} event The represents an event which takes place in the DOM.
 */
function setFormDataForPostedSuccessfully(event) {
  const form = event.target;
  const name = 'posted-successfully';
  const selector = form.querySelector(name);
  if (selector === null || form.tagName !== 'FORM') return;
  const formData = new FormData(form);
  const payload = {};
  for (const [key, value] of formData.entries()) payload[key] = value;
  sessionStorage.setItem(name, JSON.stringify(payload));
}

document.addEventListener('submit', setFormDataForPostedSuccessfully);
